/* global localData */
function emptyList() {
  document.querySelector('.teaser-list .row').innerHTML = '';
}
function prepareRenderResults(page, clear) {
  const active = document.querySelector('.tab-categories.is-active');
  // eslint-disable-next-line no-use-before-define
  ajaxCall(active ? active.dataset.filter.substring(1) : '', page, clear);
}
function initShowMore() {
  const loadMoreButton = document.querySelector('.link--load-more');
  loadMoreButton.addEventListener('click', (e) => {
    e.preventDefault();
    // eslint-disable-next-line no-use-before-define
    prepareRenderResults(Number(loadMoreButton.dataset.page), false);
  });

}
function ajaxCall(filters, page, clear) {
  const request = new XMLHttpRequest();
  request.open('POST', localData.siteURL, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  request.send(`action=getPractices&nonce=${localData.nonce}&filter=${filters}&page=${page}`);
  request.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      const response = JSON.parse(this.responseText);
      if (clear) {
        emptyList();
      }
      if (response.data.html) {
        const loadMoreButton = document.querySelector('.link--load-more');
        loadMoreButton.dataset.page = Number(loadMoreButton.dataset.page) + 1;
        document.querySelector('.teaser-list .row').innerHTML += response.data.html;
      }
      document.querySelector('.link--load-more').hidden = !!response.data.last;
    }
  };
}
const newsTemplate = document.querySelector('.listing-module-practice');
if (newsTemplate) {
  const newsFilterButtons = document.querySelectorAll('.link-filter .tab-categories');
  newsFilterButtons.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      newsFilterButtons.forEach((it) => {
        it.classList.remove('is-active');
      });
      item.classList.add('is-active');
      newsTemplate.dataset.page = '1';
      prepareRenderResults(1, true);
    });
  });
  initShowMore();
}
